import { MutableRefObject, useRef } from 'react';

import { IbUserAccountsGraphQlServiceTypes } from '../../services/IbUserAccountsServices/GraphQlService';
import { IbUserAccountsGraphQlService } from '../../services/IbUserAccountsServices/GraphQlService/index.api';
import { networkCallWithGraphQL } from '../../utils/AuthAPIUtils';

import { useAccountsRefreshAuthTokens } from '../useAccountsRefreshAuthTokens';

const useIbUserAccountsGraphQLService = () => {
  const { refreshTokenApi, getAccessToken, getRefreshToken } =
    useAccountsRefreshAuthTokens();

  const IbUserAccountsGraphQlRef: MutableRefObject<IbUserAccountsGraphQlServiceTypes | null> =
    useRef(null);

  if (IbUserAccountsGraphQlRef.current === null) {
    IbUserAccountsGraphQlRef.current = new IbUserAccountsGraphQlService(
      networkCallWithGraphQL(refreshTokenApi, getAccessToken, getRefreshToken)
    );
  }

  return {
    ibUserAccountsGraphQLService: IbUserAccountsGraphQlRef.current
  };
};

export { useIbUserAccountsGraphQLService };
